import { type ReactNode } from "react";

import { ReportsViewAssembleDndProvider } from "@/app/app/_/views/ReportsView/ReportsViewAssembleDndContext";
import {
  ReportsViewReportLayoutProvider,
  useReportsViewReportLayoutContextOrNull,
} from "@/app/app/_/views/ReportsView/ReportsViewReportLayoutContext";

/** True when the browser URL is a reports / views app route (legacy ``/app/overview`` included). */
export function isReportsAppPath(pathname: string): boolean {
  const segment = pathname
    .replace(/^\/app\/?/, "")
    .split("/")
    .filter(Boolean)[0];
  return segment === "reports" || segment === "overview" || segment === "views";
}

export function ReportsViewReportLayoutScope({
  children,
}: {
  children: ReactNode;
}) {
  const hasLayoutContext = useReportsViewReportLayoutContextOrNull() != null;
  if (hasLayoutContext) {
    return children;
  }
  return (
    <ReportsViewReportLayoutProvider>
      <ReportsViewAssembleDndProvider>
        {children}
      </ReportsViewAssembleDndProvider>
    </ReportsViewReportLayoutProvider>
  );
}
